"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const models_1 = require("../modules/models");
const rulesets_1 = require("../modules/rulesets");
const get_value_1 = __importDefault(require("../utils/get-value"));
const shallow_equal_1 = __importDefault(require("../utils/shallow-equal"));
// compares two arrays of validation errors (objects with type)
// to determine if the arrays are equal
const errorsEqual = (one, two) => {
    if (one.length !== two.length)
        return false;
    const sortArr = arr => arr.map(({ type }) => type).sort();
    const sortedOne = sortArr(one);
    const sortedTwo = sortArr(two);
    return sortedOne.reduce((acc, s, index) => acc && s === sortedTwo[index], true);
};
class DynamicField extends react_1.Component {
    static defaultProps = {
        enableRulesets: true,
        isReadOnly: false,
        isRequired: false,
        pristine: true,
        valid: true,
        value: '',
    };
    state = {
        touched: false,
    };
    shouldComponentUpdate({ validationErrors: newErrors, passthroughProps: nextPassthroughProps, value: nextValue = '', ...nextProps }, { touched }) {
        if (this.state.touched !== touched) {
            return true;
        }
        if (this.props.value !== nextValue) {
            return true;
        }
        const same = [
            'pristine',
            'valid',
            'isRequired',
            'isReadOnly',
            'label',
            'start',
            'end',
        ].every(key => nextProps[key] === this.props[key]);
        const { validationErrors, passthroughProps } = this.props;
        if (same &&
            errorsEqual(validationErrors, newErrors) &&
            (0, shallow_equal_1.default)(nextPassthroughProps, passthroughProps)) {
            return false;
        }
        return true;
    }
    handleChange = (event, normalizer) => {
        const { onChange, touched, dispatchRulesets, type, isReadOnly, ...opts } = this.props;
        if (isReadOnly)
            return;
        const value = (0, get_value_1.default)(event);
        onChange({ ...opts, type, value, normalizer });
        dispatchRulesets(opts);
    };
    handleBlur = () => {
        this.setState({
            touched: true,
        });
    };
    render() {
        const { component, ...remProps } = this.props;
        const { touched } = this.state;
        const props = {
            ...remProps,
            touched,
            onChange: this.handleChange,
            onBlur: this.handleBlur,
        };
        return react_1.default.createElement(component, props);
    }
}
const mapDispatchToProps = (dispatch, { enableRulesets }) => ({
    onChange: opts => dispatch((0, models_1.updateValueAndRun)(opts)),
    dispatchRulesets: opts => {
        if (enableRulesets) {
            dispatch((0, rulesets_1.runRulesets)(opts));
        }
    },
});
exports.default = (0, react_redux_1.connect)(null, mapDispatchToProps)(DynamicField);
//# sourceMappingURL=DynamicField.js.map